import { z } from 'zod';
import { CreateGpsIntegrationCommandGpsProvider } from '@area-restrita/api-client/model/createGpsIntegrationCommandGpsProvider';

// Interface para definir os provedores e seus schemas
export interface GpsProviderConfig {
  label: string;
  schema: z.ZodSchema;
  defaultValues: () => any;
  fields: {
    key: string;
    label: string;
    type: 'text' | 'url' | 'password';
    readOnly?: boolean;
    placeholder?: string;
    helpText?: string;
  }[];
}

// Configuração dos provedores GPS
export const gpsProviderConfigs: Record<
  CreateGpsIntegrationCommandGpsProvider,
  GpsProviderConfig
> = {
  webhook: {
    label: 'Webhook',
    schema: z.object({
      url: z.string().url('URL deve ser válida'),
    }),
    defaultValues: () => ({
      url: `${window.location.origin}/api/v1/webhook/gps/${crypto.randomUUID()}`,
    }),
    fields: [
      {
        key: 'url',
        label: 'URL do Webhook',
        type: 'url',
        placeholder: 'https://exemplo.com/webhook',
        helpText: 'URL gerada automaticamente para receber dados GPS',
        readOnly: true,
      },
    ],
  },
  mobs2: {
    label: 'Mobs2',
    schema: z.object({
      baseUrl: z.string().url('URL deve ser válida'),
      apiKey: z.string().min(1, 'Token é obrigatório'),
    }),
    defaultValues: () => ({ baseUrl: '', token: '' }),
    fields: [
      {
        key: 'baseUrl',
        label: 'URL da API Mobs2',
        type: 'url',
        placeholder: 'https://system.mobs2.com/api/integration/mobs2/{{slug}}',
      },
      {
        key: 'apiKey',
        label: 'Token de Acesso',
        type: 'password',
        placeholder: 'Insira o token de acesso',
      },
    ],
  },
  addlog: {
    label: 'Addlog',
    schema: z.object({
      baseUrl: z.string().url('URL deve ser válida'),
      token: z.string().min(1, 'Token é obrigatório'),
    }),
    defaultValues: () => ({ baseUrl: '', token: '' }),
    fields: [
      {
        key: 'baseUrl',
        label: 'URL da API Addlog',
        type: 'url',
        placeholder: 'https://sistema.addlog.com.br/api/{{slug}}/position/',
      },
      {
        key: 'token',
        label: 'Token de Acesso',
        type: 'password',
        placeholder: 'Insira o token de acesso',
      },
    ],
  },
};

// Helper para obter a label de um provedor
export const getProviderLabel = (
  provider: CreateGpsIntegrationCommandGpsProvider,
) => {
  return gpsProviderConfigs[provider]?.label || provider;
};

// Helper para obter o schema de um provedor
export const getProviderSchema = (
  provider: CreateGpsIntegrationCommandGpsProvider,
) => {
  return gpsProviderConfigs[provider]?.schema || z.object({});
};

// Helper para obter valores padrão de um provedor
export const getProviderDefaultValues = (
  provider: CreateGpsIntegrationCommandGpsProvider,
) => {
  return gpsProviderConfigs[provider]?.defaultValues() || {};
};

// Helper para obter os campos de configuração de um provedor
export const getProviderFields = (
  provider: CreateGpsIntegrationCommandGpsProvider,
): GpsProviderConfig['fields'] => {
  return gpsProviderConfigs[provider]?.fields || [];
};
